import React from "react";
import { Button, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function PermissionDenied({ fallbackPath = "/" }) {
  const navigate = useNavigate();

  return (
    <div className="container py-5 text-center">
      <Alert variant="warning">
        <h4>Access Denied</h4>

        <p className="mb-3">
          You do not have permission to access this page.
        </p>

        <Button
          variant="primary"
          onClick={() => navigate(fallbackPath, { replace: true })}
        >
          Go Back
        </Button>
      </Alert>
    </div>
  );
}
